<template>
  <v-card>
    <v-list three-line class="pa-0">
      <template v-for="(score, index) in scores">
        <v-divider v-if="index > 0" :key="index"></v-divider>
        <KillListItem :key="'kill-list-item-' + index" :score="score"
                      @go-to-game="$emit('go-to-game',score.game_id)"></KillListItem>
      </template>
    </v-list>
  </v-card>
</template>
<script>
  import KillListItem from '@/components/atoms/KillListItem';

  export default {
    props: ['scores'],
    components: { KillListItem },
  };
</script>
